var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-modal",
      on: {
        click: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "product-modal-container no-scrollbar",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "close-container" }, [
            _c(
              "p",
              {
                staticClass: "closeIcon",
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [_vm._v("< Back")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "main-container" }, [
            _c(
              "div",
              { staticClass: "image-container" },
              [
                _c(
                  "VueSlickCarousel",
                  {
                    attrs: {
                      infinite: true,
                      arrows: false,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      draggable: true,
                      dots: true
                    }
                  },
                  _vm._l(_vm.product.images, function(image) {
                    return _c("img", {
                      key: image.id,
                      staticClass: "main-image",
                      attrs: { src: image.src }
                    })
                  }),
                  0
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "information-container" }, [
              _c(
                "div",
                { staticClass: "ethos-container" },
                _vm._l(_vm.ethosTags, function(ethos) {
                  return _c(
                    "span",
                    { key: ethos, class: _vm.badgeExtraClass(ethos) },
                    [_vm._v(_vm._s(ethos))]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.showAlert
                ? _c("p", { staticClass: "red-alert" }, [
                    _vm._v(
                      "\n                  Please select your size.\n              "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isCustomHeader && _vm.variantOptions.length > 1
                ? _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedVariant,
                            expression: "selectedVariant"
                          }
                        ],
                        attrs: { id: "variantSelector" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedVariant = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.variantOptions, function(variant) {
                        return _c(
                          "option",
                          { key: variant.id, domProps: { value: variant } },
                          [_vm._v(_vm._s(variant.title))]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isCustomHeader && _vm.extraProperties.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.extraProperties, function(property, i) {
                      return _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.propertiesSelected[i],
                              expression: "propertiesSelected[i]"
                            }
                          ],
                          attrs: { id: "variantSelector" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.propertiesSelected,
                                  i,
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.changeProperty($event, property)
                              }
                            ]
                          }
                        },
                        _vm._l(property.values, function(variant) {
                          return _c(
                            "option",
                            { key: variant, domProps: { value: variant } },
                            [_vm._v(_vm._s(variant))]
                          )
                        }),
                        0
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticClass: "main-title" }, [
                _vm._v(_vm._s(_vm.product.title))
              ]),
              _vm._v(" "),
              _vm.selectedProduct && _vm.product.id == _vm.selectedProduct.id
                ? _c(
                    "button",
                    {
                      staticClass: "happybox-button yellow",
                      class: _vm.isLoading ? "isLoading" : "",
                      on: { click: _vm.goCheckout }
                    },
                    [_vm._v(_vm._s(_vm.buttonText))]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "happybox-button white",
                      on: {
                        click: function($event) {
                          return _vm.selectProduct(_vm.product)
                        }
                      }
                    },
                    [_vm._v("Select")]
                  ),
              _vm._v(" "),
              _c("p", {
                staticClass: "main-description",
                domProps: { innerHTML: _vm._s(_vm.description) }
              })
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "next-step-instructions" }, [
      _c("p", [
        _c("strong", [_vm._v("Next Step:")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "\n                  You’ll be asked to fill in your shipping and billing address, but no payment will be required. Please make sure to complete all steps to confirm your order. You’ll receive an order confirmation email once complete.\n              "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }